import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Chat from './chat';
import Email from './email';
import SMSScreen from "./sms";
import Conversation from './components/Conversation';

export default () => (
  <Switch>
    <Route path="/inbox/email/:id?" component={Email} />
    <Route path="/inbox/convo/:id?" component={Conversation} />
    <Route path="/inbox/sms/:convoId?" component={SMSScreen} />
    <Route path="/inbox/messages/:roomId?" component={Chat} />
  </Switch>
)
